"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Logo = function Logo(_ref) {
  var brand = _ref.brand,
      height = _ref.height,
      width = _ref.width,
      className = _ref.className;
  return _react["default"].createElement("img", {
    height: height,
    width: width,
    src: "https://api.logos.staccsandbox.com/".concat(brand),
    alt: brand,
    className: className
  });
};

var _default = Logo;
exports["default"] = _default;
Logo.propTypes = {
  brand: _propTypes["default"].string.isRequired,
  height: _propTypes["default"].number,
  width: _propTypes["default"].number
};
Logo.defaultProps = {
  height: 48
};